import { useCounter } from "@react-hookz/web";
import type { EditorState } from "lexical";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { EmailDesignTemplateSettings } from "../../message/editor/types/serialised-editor-design";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";

export function useSetLexicalDesign(
  template?: EmailDesignTemplateSettings,
): (val: EditorState) => void {
  const { setValue, reset, getValues } = useFormContext<MomentFormMoment>();
  const [callCount, { inc }] = useCounter(0);

  return useCallback(
    (val: EditorState) => {
      callCount === 0
        ? reset({ ...getValues(), design: { ...val.toJSON(), template } })
        : setValue("design", { ...val.toJSON(), template }, { shouldDirty: true });

      inc();
    },
    [setValue, reset, callCount, inc, getValues, template],
  );
}
